/**
 *Angular module*/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
/**
 *Shared*/
import {Utils} from '../../utils';
import {DataTableFilter} from '../../interfaces/data-table/data-table-filter';

/**
 *Global*/

@Component({
    selector: 'app-data-table-search',
    templateUrl: './data-table-search.component.html',
    styleUrls: ['./data-table-search.component.scss']
})
export class DataTableSearchComponent implements OnInit {
    @Output() taskChange: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Data object to search from filter*
     */
    @Input() data: Object;

    /**
     * Main filter*
     */
    @Input() isMainFilter = true;
    @Input() mainFilterTitle = 'Select';
    @Input() mainFilterArray;
    @Input() mainFilter;

    /**
     * Sub filter*
     */
    @Input() isSubFilter = false;
    @Input() subFilterTitle = 'Select';
    @Input() subFilterArray;

    @Input() searchValue = '';
    public searchField: any = '';

    @Input() enableDatePicker = false;
    showDatePicker = false;

    /**
     * Date variables*
     */
    filterParameters: DataTableFilter;

    /**
     * Date variables*
     */
    searchFrom;
    searchTo;

    /**
     * Check device types*
     */
    public isLaptop: boolean;
    public isMobile: boolean;

    constructor() {
        this.searchFrom = {year: moment().get('year'), month: moment().get('month'), day: moment().get('date') + 1};
        this.searchTo = {year: moment().get('year'), month: moment().get('month') + 1, day: moment().get('date') + 1};
        this.isLaptop = Utils.isLaptop();
        this.isMobile = Utils.isMobile();
    }

    ngOnInit() {
        this.showDatePicker = this.enableDatePicker;
    }

    changeFilter(type: string, data: Object) {
        if (type == 'main') {
            this.searchField = data['id'];
            this.mainFilterTitle = data['name'];
            this.searchValue = '';
            switch (data['type']) {
                case 'select' :
                    this.isMainFilter = true;
                    this.isSubFilter = false;
                    break;

                case 'list' :
                    this.subFilterTitle = 'Select';
                    this.isMainFilter = false;
                    this.isSubFilter = true;
                    this.subFilterArray = this.data[data['id']];
                    break;

                case 'text' :
                    this.isMainFilter = true;
                    this.isSubFilter = false;
                    break;

                default :
                    this.isMainFilter = true;
                    this.isSubFilter = false;
                    break;
            }
        } else {
            this.searchValue = data['id'];
            this.subFilterTitle = data['name'];
        }
    }

    onSubmit() {
        this.filterParameters = {
            search_name: this.searchField,
            search_value: this.searchValue.toString(),
            search_from: '',
            search_to: ''
        };
        if (this.enableDatePicker && this.showDatePicker) {
            this.filterParameters = {
                ...this.filterParameters,
                search_from: moment().set({'year': this.searchFrom.year, 'month': this.searchFrom.month - 1, 'date': this.searchFrom.day}).format('YYYY-MM-DD'),
                search_to: moment().set({'year': this.searchTo.year, 'month': this.searchTo.month - 1, 'date': this.searchTo.day}).format('YYYY-MM-DD')
            };
        }
        this.taskChange.emit(this.filterParameters);
    }

}
